module.exports = ".stack\n{\n    position: relative\n}"